<template>
    <div
        class="cz2-renderer-exclude"
        :class="[
            'bg-stone-100 lg:hidden duration-300 ease-in-out flex flex-col justify-center transition-all flex-shrink max-h-max absolute bottom-0 w-full',
            isOpen ? 'p-4 border-t border-stone-300' : 'p-0',
        ]"
        :style="`height: ${isOpen ? elementHeight : '0px'}; min-height: ${isOpen ? elementHeight : '0px'}; overflow:${overflow};`"
    >

        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            overflow: {
                type: String,
                default: 'visible',
            },
            elementHeight: {
                type: String,
                default: '0px',
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            afterEnterTransition() {
                // Clean up some console log errors.
            },
        },
    };
</script>
